/** Component definitions for the ECS. A component is a plain data record; its
 * `ComponentType<T>` is an opaque, typed handle used to store/query it. */
import type { Brand } from '@settlers/shared';

export type ComponentId = Brand<number, 'ComponentId'>;

export interface ComponentType<T> {
  readonly id: ComponentId;
  readonly name: string;
  /** Produces a fresh default instance (used by factories / deserialisation). */
  readonly create: () => T;
}

let nextComponentId = 0;

/**
 * Declare a component type. Example:
 *   const Position = defineComponent('Position', () => ({ x: 0, y: 0 }));
 * The generic is inferred from the factory's return type.
 */
export const defineComponent = <T>(name: string, create: () => T): ComponentType<T> => ({
  id: nextComponentId++ as ComponentId,
  name,
  create,
});
